export default __webpack_public_path__ + "static/air_compressor_w.754fe453d68119d041c33f29d5a1c8ae.svg";